export const validationConfig = {
    minCompanySearchLength: 2,
    minStartingYearDate: new Date('2010/01/01'),
    maxUpperStartingYears: 30,
    lowerLeaseExpirationYear: new Date('2015/01/01').setHours(0, 0, 0, 0),
    upperLeaseExpirationYear: 20,
    minLeaseYears: 1,
    maxLeaseYears: 25,
    rsfMin: 10,
    rsfMax: 1000000,
};
